"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventListPageActions;
(function (EventListPageActions) {
    EventListPageActions["AccessRequestSent"] = "AccessRequestSent";
    EventListPageActions["AccessRequestPromptShown"] = "AccessRequestPromptShown";
    EventListPageActions["AccessRequestPromptHidden"] = "AccessRequestPromptHidden";
})(EventListPageActions || (EventListPageActions = {}));
exports.default = EventListPageActions;
